import { React, useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import useWeb3Forms from '@web3forms/react';

export default function MakeDonation() {
  const [serverResponse, setServerResponse] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting, isValid }
  } = useForm({ mode: 'onChange' });

  const { submit: submitForm } = useWeb3Forms({
      access_key: process.env.REACT_APP_EMAIL_ACCESS_TOKEN,
      settings: {
        from_name: 'Tu Es Belle Foundation',
        subject: 'New Donation Pledge Submission'
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      onSuccess: (message) => {
        setServerResponse({ ok: true, message });
        reset();
        setTimeout(() => {
          setServerResponse(null);
        }, 5000);
      },
      onError: (message) => {
          setServerResponse({ ok: false, message });
          setTimeout(() => {
            setServerResponse(null);
      }, 5000);
    }
  });

  return (
    <div className="p-4 rounded shadow bg-white">
      <div className="section-title">
        <h4 className="title mb-3">Pledge a Donation</h4>
        <p className="mb-0 text-muted">
          Please fill out the donation pledge form. We shall be in touch. Thank you for your support.
        </p>
      </div>

      <form className="mt-4" onSubmit={handleSubmit(submitForm)}>
      <input
              type="checkbox"
              id=""
              className="hidden"
              style={{ display: "none" }}
              {...register("botcheck")}></input>

        <div className="row">
          <div className="col-12">
            <div className="mb-3">
              <label className="form-label fw-semibold" htmlFor="name">
                Your Name <span className="text-danger">*</span>
              </label>
              <input
                {...register('name', { required: 'Name is required.', maxLength: 80 })}
                type="text"
                className="form-control"
                placeholder="Your name"
              />
              {errors.name && <div className="text-danger mt-1">{errors.name.message}</div>}
            </div>
          </div>

          <div className="col-md-6 col-12">
            <div className="mb-3">
              <label className="form-label fw-semibold" htmlFor="email">
                Your Mail <span className="text-danger">*</span>
              </label>
              <input
                {...register('email', { required: 'Email is required.', pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Please enter a valid email",
                  }, })}
                id='email'
                type="email"
                className="form-control"
                placeholder="Your email"
              />
              {errors.email && <div className="text-danger mt-1">{errors.email.message}</div>}
            </div>
          </div>

          <div className="col-md-6 col-12">
            <div className="mb-3">
              <label className="form-label fw-semibold" htmlFor="number">
                Phone No. <span className="text-danger">*</span>
              </label>
              <input
                {...register('number', { required: 'Phone number is required.' })}
                type="text"
                className="form-control"
                placeholder="your phone number"
              />
              {errors.number && <div className="text-danger mt-1">{errors.number.message}</div>}
            </div>
          </div>

          <div className="col-12">
            <div className="mb-3">
              <label className="form-label fw-semibold">I Want to Donate for</label>
              <select
                defaultValue=""
                {...register('reason', { required: 'Please select a reason.' })}
                className="form-select"
              >
                <option value="" disabled>
                  Select reason
                </option>
                <option value="Rape victims">Rape victims</option>
                <option value="Food For Orphans">Food For Orphans</option>
                <option value="Home For Homeless">Home For Homeless</option>
                <option value="School drops">School drops</option>
                <option value="Oppressed women">Oppressed women</option>
                <option value="Single mums/Teen mums">Single mums/Teen mums</option>
              </select>
              {errors.reason && <div className="text-danger mt-1">{errors.reason.message}</div>}
            </div>
          </div>

          <div className="col-12">
            <label className="form-label fw-semibold">
              How much do you want to donate? <span className="text-danger">*</span>
            </label>
            <div className="mb-3">
              <div className="input-group mb-3">
                <span className="input-group-text" id="basic-addon1">
                  $
                </span>
                <input
                  {...register('amount', {
                    required: 'Donation amount is required.',
                    min: { value: 1, message: 'Minimum donation amount is $1.' }
                  })}
                  type="number"
                  className="form-control"
                  placeholder="Enter Amount"
                  aria-describedby="inputGroupPrepend"
                />
              </div>
              {errors.amount && <div className="text-danger mt-1">{errors.amount.message}</div>}
            </div>
          </div>

          <div className="col-12">
            <div className="form-check">
              <input
                {...register('terms', { required: 'You must agree to the terms and conditions.' })}
                className="form-check-input"
                type="checkbox"
                id="terms"
              />
              <label className="form-check-label" htmlFor="terms">
                I agree to the{' '}
                <Link to="/terms" className="text-primary">
                  Terms and Conditions
                </Link>
                .
              </label>
              {errors.terms && <div className="text-danger mt-1">{errors.terms.message}</div>}
            </div>
          </div>

          <div className="col-12 mt-3">
            {serverResponse && (
                <div className={`alert ${serverResponse.ok ? 'alert-success' : 'alert-danger'}`} role="alert">
                    {serverResponse.message}
                </div>
            )}
            <button type="submit" className="btn btn-primary" disabled={!isValid || isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit Pledge'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
